import { useState as r, useCallback as c } from "react";
const u = (o = !1) => {
  const [s, t] = r(o), n = c((e) => {
    t((l) => e !== void 0 ? e : !l);
  }, []);
  return [s, n];
};
export {
  u as useToggle
};
//# sourceMappingURL=useToggle.mjs.map
